export function isKeySpace(ev) {
  return ev.key === ' ';
}
